

window.triggerEvent = function(event, params) {
    if (events[event] && events[event].length > 0) {
        for (var i = 0, j = events[event].length; i < j; i++) {
            events[event][i].call(params, params);
        }
    }
};

var events = {}, // 注册的APP事件的集合
    appHelper = {
        /**
         * 往appHelp注入外部组件
         */
        init: function(obj) {
            for (var i in obj) {
                if (obj.hasOwnProperty(i)) {
                    appHelper[i] = obj[i];
                }
            }
        },

        /**
         * 绑定一个全局的方法，获得全局的标志
         */
        bindGlobalFunc: (function() {
            window.globalFunc = window.globalFunc || {};
            var timer = 10000;
            return function(func) {
                var str = timer++;
                window.globalFunc[str] = func;
                timer++;
                return "window.globalFunc[" + str + "]";
            };
        })(),

        /**
         * @return 		json(app:是不是APP，version:APP的版本号如果不是APP则返回0，weChat:是否微信浏览器)
         */
        checkApp: function() {
            var userAgent = navigator.userAgent,
                strReg = userAgent.match(/AYKAPP_(\w+)_([\d.]+)/),
                isApp = !!strReg,
                isWeChat = false,
                appVersion = 0,
                newUserAgent;

            if (isApp) {
                strReg = strReg[0];
                var reg = new RegExp("(AIYUKEAPP)@.*([;])");
                newUserAgent = userAgent.match(reg);
                if (newUserAgent) {
                    var matched = newUserAgent[0].split("@");
                    appVersion = parseInt(matched[2].replace(".", ""));
                } else {
                    appVersion = parseInt(strReg);
                }
                // appVersion = parseInt(userAgent.match(/@([\w\.]+)\@/)[0])
            }

            if (userAgent.indexOf("MicroMessenger") > -1) {
                isWeChat = true;
            }

            return {
                app: isApp,
                weChat: isWeChat,
                version: appVersion,
                ios: !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
                android:
                userAgent.indexOf("Android") > -1 ||
                userAgent.indexOf("Adr") > -1
            };
        },

        /**
         * 设置HTML界面为已登录状态
         */
        setLogin: function() {
            document.querySelectorAll("[name='islogin']")[0].value = "1";
        },

        /**
         * 低于等于APP 2.4
         * 打开App的登录界面
         */
        checkLogin: function(showLogin, afterLogin) {
            var isLogin =
                document.querySelectorAll("[name='islogin']")[0].value ===
                "1";
            if (showLogin === undefined) {
                showLogin = true;
            }

            if (isLogin) {
                return true;
            } else {
                appHelper.checkTYSNAV(
                    function(TYSNAV) {
                        showLogin && appHelper.pipe("showLogin");
                        afterLogin && afterLogin();
                    },
                    null,
                    function(error) {
                        console.log("error", error);
                        if (error === "notapp") {
                            try {
                                window.location.href = document.querySelectorAll(
                                    "[name='login_url']"
                                )[0].value;
                            } catch (e) {}
                        } else if (error === "notsupport") {
                            appHelper.alert(
                                "你需要更新APP才能继续操作哦！"
                            );
                        }
                    }
                );
                return false;
            }
        },

        /**
         * 高于等于App 2.5
         * 打开App的登录界面
         * 解决App和webview登录的问题
         */
        checkAppLogin: function(showLogin, afterLogin) {
            var isLogin =
                document.querySelectorAll("[name='islogin']")[0].value ===
                "1";

            if (showLogin === undefined) {
                showLogin = true;
            }

            if (isLogin) {
                return true;
            } else {
                appHelper.checkTYSNAV(
                    function(TYSNAV) {
                        showLogin && appHelper.pipe("showAppLogin");
                        afterLogin && afterLogin();
                    },
                    25,
                    function(error) {
                        if (error === "notapp") {
                            try {
                                window.location.href = document.querySelectorAll(
                                    "[name='login_url']"
                                )[0].value;
                            } catch (e) {}
                        } else if (error === "notsupport") {
                            appHelper.alert(
                                "你需要更新APP才能继续操作哦！"
                            );
                        }
                    }
                );
                return false;
            }
        },

        /**
         * @param:func 		function 检测TYSNAV成功执行回调
         * @param:version 	number 	   对APP进行版本检测
         * @param:error		function 检测失败执行的回调 （none:不存在TYSNAV，notapp:不在APP中打开，notsupport:版本不支持, error:程序运行时错误）
         */
        checkTYSNAV: function(func, version, error) {
            var app = appHelper.checkApp();
            if (app.app === false) {
                error && error("notapp");
                return appHelper;
            }

            if (
                appHelper.checkNewIOSSupport() ||
                typeof TYSNAV !== "undefined"
            ) {
                if (typeof version === "number" && version > app.version) {
                    error && error("notsupport");
                    return appHelper;
                }

                try {
                    func();
                } catch (e) {
                    error && error("error");
                }

                return appHelper;
            } else {
                error && error("none");
                return appHelper;
            }
        },

        /**
         *  弹出消息提示框
         * @param:msg       提示的消息内容 (必填)
         * @param:title     提示的消息标题 (必填 不想写值 置为null)
         * @param:onOk      点击确认触发事件(选填)
         */
        alert: function(msg, title, onOk) {
            var argu = arguments;
            return appHelper.checkTYSNAV(
                function() {
                    appHelper.pipe(
                        "showToast",
                        [msg]
                    );
                },
                null,
                function() {
                    window.alert(msg);
                }
            );
        },

        /**
         *  弹出确认选择框
         * @param:title			提示的消息标题
         * @param:message		提示的消息内容
         * @param:onOk			点击确认触发事件
         * @param:onCancel		点击取消触发事件
         */
        showConfirm: function(title, message, onOk, onCancel) {
            return appHelper.checkTYSNAV(
                function() {
                    var funcOk = appHelper.bindGlobalFunc(onOk),
                        funcCancel = appHelper.bindGlobalFunc(onCancel);
                    appHelper.pipe(
                        "showConfirm",
                        [title, message, funcOk, funcCancel]
                    );
                },
                null,
                function() {
                    if (appHelper["dialogMobile"]) {
                        appHelper["dialogMobile"].confirm(
                            title,
                            message,
                            onOk,
                            onCancel
                        );
                    }
                }
            );
        },

        /**
         * 显示APP加载中的效果
         */
        showLoading: function(msg) {
            msg = msg || "加载中";
            return appHelper.checkTYSNAV(
                function() {
                    appHelper.pipe(
                        "showLoading",
                        [msg]
                    );
                },
                null,
                function(error) {
                    if (error === "notapp") {
                        var loadingDom = $("#showLoading");
                        if (loadingDom && loadingDom.length) {
                            loadingDom.show();
                        } else {
                            $("body").append(
                                '<div class="showLoading" id="showLoading"><div><i></i><span>' +
                                msg +
                                "</span></div></div>"
                            );
                        }
                    }
                }
            );
        },

        /**
         * 隐藏APP加载中的效果
         */
        hideLoading: function() {
            return appHelper.checkTYSNAV(
                function() {
                    appHelper.pipe("hideLoading");
                },
                null,
                function(error) {
                    if (error === "notapp") {
                        var loadingDom = $("#showLoading");
                        if (loadingDom.length) {
                            loadingDom.hide();
                        }
                    }
                }
            );
        },

        /**
         * 打开地区选择器 app内使用TYSNAV.selectLocation接口 h5使用areaSelect模块
         * @param {json} location 地址数据
         * @param {String} callback 回调操作
         */
        selectLocation: function(location, callback, cityPicker) {
            if (location) {
                window.GLOBAL_LOCATION = location;
            }

            return appHelper.checkTYSNAV(
                function() {
                    appHelper.pipe(
                        "selectLocation",
                        [
                            JSON.stringify(window.GLOBAL_LOCATION),
                            appHelper.bindGlobalFunc(function(data) {
                                var d = {};
                                try {
                                    d = JSON.parse(data);
                                } catch (e) {}
                                callback(d);
                            })
                        ]
                    );
                },
                null,
                function() {
                    // cityPicker由外部传入
                    cityPicker($, window.GLOBAL_LOCATION, function(data) {
                        callback(data);
                    });
                }
            );
        },

        /**
         * @param:event			向APP注册一个事件名，并监听APP端发过来的消息
         * @param:callback		APP触发事件后的回调
         */
        onAppEvent: function(event, callback) {
            return appHelper.checkTYSNAV(function(TYSNAV) {
                if (events[event] === undefined) {
                    events[event] = [callback];
                    appHelper.pipe(
                        "regEvent",
                        [event]
                    );
                } else {
                    events[event].push(callback);
                }
            });
        },

        /**
         * 取消一个监听的事件
         * @param:event		事件名
         */
        offAppEvent: function(event) {
            delete events[event];
            return appHelper;
        },

        /**
         * APP初始化
         * 如果检测到TYSNAV注入完成，触ex发
         */
        onAppReady: function(func) {
            if (appHelper.checkApp().app) {
                var timer = function() {
                    if (
                        appHelper.checkNewIOSSupport() ||
                        typeof TYSNAV !== "undefined"
                    ) {
                        func();
                    } else {
                        window.setTimeout(function() {
                            timer();
                        }, 200);
                    }
                };
                timer();
            }
            return appHelper;
        },

        /**
         * 不在APP内处理函数
         * @params func {function}  回调函数
         */
        onNotApp: function(func) {
            if (!appHelper.checkApp().app) {
                func();
            }
            return appHelper;
        },

        /**
         * APP刷新界面
         * 如果是APP内部，且APP版本号大于等于30，需要调用原生的方法
         * 如果是手机浏览器上，需要调用执行H5func，h5func里面有使用者自己写的跳转方法
         */
        reloadPage: function(h5func) {
            return appHelper.checkTYSNAV(
                function(TYSNAV) {
                    appHelper.pipe(
                        "reloadPage",
                        []
                    );
                },
                30,
                function() {
                    h5func();
                }
            );
        },

        /**
         * 检测是否是IOS8以上并且是APP3.0以上的版本
         * WKWebView 只能采用最新的方式与原生交互
         * @returns {boolean}
         */
        checkNewIOSSupport: function() {
            if (window.webkit && window.webkit.messageHandlers) {
                return true;
            } else {
                return false;
            }
        },

        /**
         * JS与原生交互的管道
         * @param name
         * @param params
         */
        pipe: function(name, params) {
            if (
                Object.prototype.toString.call(params) !== "[object Array]"
            ) {
                params = [];
            }
            try {
                if (appHelper.checkNewIOSSupport()) {
                    var handlers = window.webkit.messageHandlers;
                    if (handlers[name]) {
                        if (params.length === 0) {
                            // IOS 必须要有个参数才能传递成功
                            params.push("0");
                        }
                        handlers[name].postMessage(params);
                    }
                } else if (TYSNAV && TYSNAV[name]) {
                    TYSNAV[name].apply(TYSNAV, params);
                }
            } catch (e) {}

            return appHelper;
        }
    };

export default appHelper;


// WEBPACK FOOTER //
// ./src/lib/appHelper.js